var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYouTube = function SvgYouTube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.72 3.301c-.305-1.2-1.205-2.147-2.347-2.468C22.303.25 14 .25 14 .25S5.699.25 3.628.833C2.486 1.154 1.587 2.1 1.281 3.301.727 5.478.727 10.02.727 10.02s0 4.542.554 6.718a3.36 3.36 0 0 0 2.347 2.429c2.07.583 10.373.583 10.373.583s8.301 0 10.372-.583a3.36 3.36 0 0 0 2.347-2.429c.555-2.176.555-6.718.555-6.718s0-4.542-.555-6.719ZM11.286 14.143V5.896l6.938 4.124-6.938 4.123Z"
  })));
};
export default SvgYouTube;